import { REGULARS } from 'utils';

export function getUploadedFileName(fileKey: string = '') {
	const res = fileKey.match(REGULARS.fileName);
	return res ? res[1] : '';
}
